// Devolucion por monto: calculos compartidos con el backend de SmartPay (utils/orderRefunds.js).
// Deben dar el mismo resultado que alla, porque el backend recalcula la linea y es quien emite la
// nota de credito a la DGI.

const toNumber = (value) => {
   const numericValue = Number(value);
   return Number.isFinite(numericValue) ? numericValue : 0;
};

// Misma regla del backend (utils/calculateTotals.js): el impuesto se redondea hacia arriba al centavo
export const roundUpToTwoDecimals = (value) => {
   const decimals = value.toString().split('.')[1];

   if (decimals && decimals.length > 2 && parseInt(decimals[2]) > 0) {
      return Math.ceil(value * 100) / 100;
   }

   return parseFloat(value.toFixed(2));
};

export const roundCurrency = (value) => Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;

// Separa un monto con impuesto en precio neto + impuestos de la linea. Si ningun neto reproduce el
// monto exacto se usa el mas cercano hacia abajo, para no devolver nunca mas de lo digitado.
export const splitGrossRefundValue = (grossValue, taxes = []) => {
   const targetCents = Math.round(toNumber(grossValue) * 100);
   const totalRate = (taxes || []).reduce((total, tax) => total + toNumber(tax.taxtValue), 0);
   const estimatedNetCents = Math.round(targetCents / (1 + totalRate));

   for (let netCents = estimatedNetCents + 2; netCents >= Math.max(1, estimatedNetCents - 3); netCents--) {
      const net = netCents / 100;
      const taxTotals = (taxes || []).map(tax => roundUpToTwoDecimals(net * toNumber(tax.taxtValue)));
      const grossCents = Math.round((net + taxTotals.reduce((total, tax) => total + tax, 0)) * 100);

      if (grossCents <= targetCents) {
         return { net, taxTotals, gross: grossCents / 100 };
      }
   }

   return null;
};

// Valor con impuesto de una linea completa de la orden original (cantidad x precio - descuento + ITBMS)
export const getLineGrossValue = (product = {}) => {
   const amount = toNumber(product.amount);
   const unitDiscount = product.unit_discount !== undefined && product.unit_discount !== null
      ? toNumber(product.unit_discount)
      : amount > 0 ? toNumber(product.discount) / amount : 0;
   const netUnit = toNumber(product.price) - unitDiscount;
   const taxTotal = (product.taxes || []).reduce(
      (total, tax) => total + roundUpToTwoDecimals(amount * toNumber(tax.taxtValue) * netUnit),
      0
   );

   return roundCurrency(amount * netUnit + taxTotal);
};

// Linea lista para enviar al backend cuando se devuelve un monto: 1 unidad al precio neto equivalente.
export const buildAmountReturnLine = (product = {}, grossValue) => {
   const split = splitGrossRefundValue(grossValue, product.taxes);

   if (!split) {
      return { ...product, amount: 0, cantidadItem: 0, refund_mode: "amount", refund_value: 0 };
   }

   return {
      ...product,
      amount: 1,
      cantidadItem: 1,
      price: split.net,
      discount: 0,
      unit_discount: 0,
      taxes: (product.taxes || []).map((tax, index) => ({ ...tax, total: split.taxTotals[index] })),
      refund_mode: "amount",
      refund_value: split.gross
   };
};
